import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import NavBar from '../components/navbar'
import { SALESFORCE_EMBED_EXCEPTION_CODE } from '../api/vsApi';

class EmbeddedErrorScreen extends React.PureComponent {

    constructor(props) {
        super(props);
    }

    handleClick = () => {
        this.props.history.goBack();
    }

    renderErrorMessage = () => {
        return(
            <div className="col" id="first">
                <Alert show={true} variant="danger">
                    <Alert.Heading>{this.props.strings.ERROR_HEADER}</Alert.Heading>
                    <p>
                        {this.props.strings.ERROR_PREFIX}<br/>
                        <b>{this.props.strings.ERROR_HEADER+' '+SALESFORCE_EMBED_EXCEPTION_CODE+': '+this.props.strings.SFEE_ERROR_MESSAGE}</b>
                    </p>
                    <hr />
                    <div className="d-flex justify-content-center">
                        <Button onClick={this.handleClick} variant="danger">
                            {this.props.strings.ERROR_HOME_LINK}
                        </Button>
                    </div>
                </Alert>
            </div>
        );
    }

    render() {
        // HTML here with bootstrap styles..
        let errorMessage = this.props.strings.BASIC_ERROR;
        return (
            <div className="container-full">
                <NavBar language={this.props.language}/>
                <div className="container">
                    <div className="col" id="first">
                        {this.renderErrorMessage()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
        errorMessage: state.api.errorMessage,
        isError: state.api.isError,
    }
}

const ConnectedEmbeddedErrorScreen = connect(
    mapStateToProps
)(EmbeddedErrorScreen);
export default ConnectedEmbeddedErrorScreen;
